import { Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth.service';
import { News } from './../news.model';
import { Component, Injector } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/components/base-form-component/base-form-component';
import { Club } from '../../clubs/club.model';
import { NewsService } from '../news.service';
import { ClubsService } from '../../clubs/clubs.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
    selector: 'ng-news',
    templateUrl: 'news-form.component.html',
    styleUrls:['news-form.component.css']
})

export class NewsFormComponent extends BaseFormComponent<News>{

    public clubs:Array<Club>;
    public isThereCitiesInLocalStorage:boolean;

    
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '200px',
    minHeight: '0',
    maxHeight: '200px',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Introduza o texto aqui...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    // uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    // toolbarHiddenButtons: [
    //   ['bold', 'italic'],
    //   ['fontSize']
    // ]
  };

    constructor(
      protected injector: Injector,
      protected newsServ:NewsService,
      public  clubsServ:ClubsService
    ) {
        super(injector,'news','/admin/news',News.fromJsonToObject,newsServ);
    }

    protected initChildMethods(): void {
        !!localStorage.getItem('clubs')?
        this.isThereCitiesInLocalStorage=true:
        this.isThereCitiesInLocalStorage=false

        if(this.isThereCitiesInLocalStorage){
            this.clubs=this.clubsServ.buildArrayOfObjects(JSON.parse(localStorage.getItem("clubs")));
            return;
        }

        this.formSubscription.add(this.clubsServ.getAll().subscribe(clubs => {
            this.clubs=clubs
            this.saveInLocalStorage(clubs)
        }))
    }

    private saveInLocalStorage(clubs:Array<Club>) {
        localStorage.setItem('clubs',JSON.stringify(clubs))
    }

    protected buildForm(): void {

        this.objectForm = this.formBuilder.group({
            title: this.formBuilder.control(null,[Validators.required]),
            description: this.formBuilder.control(null,[Validators.required]),
            pic: this.formBuilder.control(null,[this.currentAction!=='edit'?Validators.required:Validators.nullValidator]),
            clubs_id: this.formBuilder.control(null,[Validators.required]),
            estados_id: this.formBuilder.control(null,[Validators.required]),
            users_id: this.formBuilder.control(this.auth.user.id),
            id: this.formBuilder.control(null)
          })

          this.imageInputControlName='photo';
    }

    protected initChildProprieties(): void {
        this.isThereCitiesInLocalStorage=false;
    }


}